<template>
  <div class="move-window">
    <div
      v-if="show"
      @mouseover="mouseover"
      @mouseout="mouseout"
      class="box"
      :style="style"
      ref="moveWindowRef"
    >
      <span class="close" @click="close">关闭</span>
      <h1 class="title" slot="title">{{ title }}</h1>
      <!-- 定义一个slot -->
      <slot
        ><div>{{ content }}</div></slot
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "MoveWindow",
  props: {
    title: {
      type: String,
      required: false,
      default: "",
    },
    content: {
      type: String,
      required: false,
      default: "特别提示：这仅仅是一个测试，不要慌。",
    },
    divStyle: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  computed: {
    // 计算 top 和 left 的样式
    style() {
      return {
        //:style="{ top: top + 'px', left: left + 'px' }"
        ...this.divStyle,
        top: this.top + "px",
        left: this.left + "px",
      };
    },
  },
  data() {
    return {
      show: true, // 是否展现飘窗
      stepX: 1, // 水平方向的步长
      stepY: 1, // 垂直方向的步长
      timer: null, // 定时器
      maxTop: 0, // 最大的 top 值
      maxLeft: 0, // 最大的 left 值
      top: 0,
      left: 0,
    };
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    // dom 销毁前清除定时器
    clearInterval(this.timer);
  },
  methods: {
    // 初始化飘窗规则
    init() {
      let width = 0;
      let height = 0;
      if (this.$refs.moveWindowRef) {
        width = this.$refs.moveWindowRef.offsetWidth;
        height = this.$refs.moveWindowRef.offsetHeight;
      }
      console.log("wwwwclog", width, height);
      // 设置最大的top和left值：根元素可视区域宽高 - 飘窗的宽高 - 边距
      this.maxTop = document.documentElement.clientHeight - height;
      this.maxLeft = document.documentElement.clientWidth - width;

      // 设置 top 和 left 的初始值
      this.top = 0;
      this.left = 0;

      // 创建定时器前清除定时器，避免类似在 onresize 中调用 init() 时，产生多个定时器
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.move();
      }, 20);

      this.onresize();
    },
    // 移动函数
    move() {
      if (this.top >= this.maxTop || this.top < 0) {
        this.stepY = -this.stepY;
      }
      if (this.left >= this.maxLeft || this.left < 0) {
        this.stepX = -this.stepX;
      }

      this.top += this.stepY;
      this.left += this.stepX;
    },
    // 鼠标悬浮在飘窗时停止移动
    mouseover() {
      clearInterval(this.timer);
    },
    // 鼠标离开飘窗时恢复移动
    mouseout() {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.move();
      }, 20);
    },
    // 关闭飘窗
    close() {
      clearInterval(this.timer);
      this.show = false;
    },
    // 窗口大小调整时重置飘窗规则
    onresize() {
      const that = this;
      window.onresize = function () {
        that.init();
      };
    },
  },
};
</script>

<style scoped lang="less">
.move-window {
  position: relative;
}
.title {
  width: calc(100% - 30px);
  font-size: 20px;
}
.box {
  background: #9cdf65;
  width: 400px;
  height: 250px;
  border-radius: 5px;
  position: fixed;
  text-align: left;
  padding: 10px;
  color: #ffffff;
  top: 0;
  left: 0;
  // overflow: hidden;
  z-index: 9998;

  .close {
    text-align: right;
    position: absolute;
    right: 10px;
    top: 10px;
    color: #2c2c2c;
    cursor: pointer;
    z-index: 9998;
  }

  > div {
    margin-top: 10px;
  }
}
</style>
